import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Redirect} from 'react-router-dom'
import {Mutation} from 'react-apollo'
import ChooseProductsButton from 'components/shared/ChooseProductsButton'

const createWeborderMutation = gql`
  mutation CreateWebOrder($input: WebOrderInput!) {
    CreateWebOrder(input: $input) {
      webOrder {
        id
      }
    }
  }
`

const CreateWebOrderButton = ({estateId}) => {
  const [webOrder, setWebOrder] = useState(null)

  if (webOrder) {
    return (
      <Redirect to={`/bestilling/${webOrder.id}`} />
    )
  }
  return (
    <Mutation
      mutation={createWeborderMutation}
      onCompleted={({CreateWebOrder}) => {
        setWebOrder(CreateWebOrder.webOrder)
      }}
    >
      {(createWebOrder, {loading}) => (
        <ChooseProductsButton
          type="add-products"
          loading={loading}
          disabled={loading}
          onClick={() => {
            createWebOrder({
              variables: {
                input: {
                  estateId,
                }
              }
            })
          }}
        >
          Bestill flere produkter
        </ChooseProductsButton>
      )}
    </Mutation>
  )
}

export default CreateWebOrderButton
